// Logto (OIDC) configuration.
//
// Values are inlined by CRA at build time, so the compose stack passes them as
// build args. See docker-compose.yml and the Logto setup notes in the root README.

import { UserScope } from '@logto/react';

// The API resource the backend validates tokens against. Access tokens minted
// for this indicator carry `aud` = this value; the backend checks it.
export const API_RESOURCE =
  process.env.REACT_APP_LOGTO_API_RESOURCE || 'https://luxottica.parallelia.com/api';

// Roles this app knows about. Kept in sync with the roles created in Logto by
// Backend-new/scripts/seed_logto.py, which also creates one API-resource
// permission per role.
export const KNOWN_ROLES = ['admin', 'manager', 'reviewer', 'user', 'client'];

export const logtoConfig = {
  endpoint: process.env.REACT_APP_LOGTO_ENDPOINT || 'https://auth.parallelia.com',
  appId: process.env.REACT_APP_LOGTO_APP_ID || '',
  resources: [API_RESOURCE],
  scopes: [
    UserScope.Email,
    UserScope.Profile,
    // Puts the user's role names in the ID token claims.
    UserScope.Roles,
    // Ask for the per-role API permissions too. Logto only grants the ones the
    // user's roles actually hold, so the access token's `scope` ends up listing
    // their roles - which is how the backend reads them without a custom JWT
    // template. Requesting a permission the user lacks is simply not granted.
    ...KNOWN_ROLES,
  ],
};

// Where Logto sends the browser back to after sign-in / sign-out. Both must be
// registered on the Logto application, or the redirect is rejected.
export const REDIRECT_URI = `${window.location.origin}/callback`;
export const POST_SIGN_OUT_REDIRECT_URI = `${window.location.origin}/login`;

// Where a pre-login deep link is parked across the OIDC round-trip.
export const RETURN_URL_KEY = 'logto:returnUrl';

// This deployment serves exactly one project, so access checks that used to be
// per-project collapse to a constant.
export const PROJECT_ID = 'luxottica';
